<template>
	<div class="home">
		<EncabezadoFormulario></EncabezadoFormulario>

		<div id="content" class="snap-content bg-home">
			<div class="container">
				<div class="header-clear mt-15"></div>
				
				<div class="row">
					<div class="col-md-12">
						<h3 class="mt-0 text-center">Valoración Solicitud Vacaciones</h3>
						<hr />
					</div>
				</div>
				
				<div class="row" v-if="datosVacacionesParaValoracion.message">
					<div class="col-md-4"></div>
					<div class="col-md-4">
						<div class="alert alert-warning" align="justify">
							<h4>{{datosVacacionesParaValoracion.message}}</h4>
						</div>
					</div>
					<div class="col-md-4"></div>
				</div>


				<div class="row" v-else>
					<div class="col-md-4"></div>
					
					<div class="col-md-4" v-if="!valoracionEnviada">
						<form 
							id="formSolicitudNuevaContrasenia" 
							class="form-horizontal"
							@submit.prevent="enviarValoracionSolicitudVacaciones"
						>
							<div class="alert alert-success" align="justify">
								<h4>Datos de la solicitud:</h4>
								<ul style="margin-left:15px;">
									<li><b>Empleado: </b>{{nombreTrabajador}}</li>
									<li><b>Fechas: </b>de {{fechaDesde}} a {{fechaHasta}}</li>
									<li><b>Núm. de días: </b>{{dias}}</li>
								</ul>
							</div>
							<hr />
							<div class="alert alert-warning" align="justify">
								<h4>Respuesta Responsable:</h4>
								<input type="radio" id="SI" value="1" v-model="valoracion" class="radio_aprob">
								<label for="SI">Favorable</label>

								<br />
								
								<input type="radio" id="NO" value="0" v-model="valoracion" class="radio_aprob">
								<label for="NO">Desfavorable</label>

								<div>&nbsp;</div>
								
								<label class="control-label" style="margin-bottom:10px;">Observaciones</label>
								<br />
								<textarea rows="5" v-model="observaciones" placeholder="¿Alguna observación?" style="width:100%; padding: 10px;"/>

		<div>&nbsp;</div>
								<div class="row log-sec">
									<div class="col-md-6">
										<input
										:disabled="enviandoDatosFormulario"
											type="submit"
											class="btn btn-primary"
											id="btnSave"
											:value="textoBtnEnvio"
										/>
									</div>
									<div class="col-md-6">
										<input type="button" class="btn btn-success" value="Cancelar" onclick="window.location.href = '/'">
									</div>
								</div>
							</div>
						</form>  
					</div>
					<div class="col-md-4"></div>
				</div>
			</div>
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<br />
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
    // @ is an alias to /src
    import EncabezadoFormulario from "@/components/EncabezadoFormulario.vue";
    import Footer from "@/components/Footer.vue";
	import router from "@/router";


    export default {
		name: "ValoracionResponsableVacaciones",
        components: {
            EncabezadoFormulario,
			Footer,
        },
		data() {
			return {
				valoracion:'1',
				observaciones: '',
				valoracionEnviada: false,
				enviandoValoracion: false,
			}
		},
		beforeCreate(){
			this.valoracionEnviada = false;

			if (this.$route.params.id_vacaciones){
				let id_vacaciones = this.$route.params.id_vacaciones;
				
				this.$store.dispatch({
					type: 'obtenerDatosSolicitudVacacionesParaValoracion',
					id_vacaciones: id_vacaciones
				});
			}
		},
		mounted() {
			document.body.classList.remove("bg-login");
			document.body.classList.remove("login-page");
			// this.$refs.email.focus();

			this.$store.commit('establecerEstadoEnviandoDatosFormulario', false);
        	this.$store.commit('establecerGuardadoOK', false);
		},
		methods:{
			enviarValoracionSolicitudVacaciones: function(){
				this.$store.dispatch({
					type: 'enviarValoracionSolicitudVacaciones',
					id_comunicacion: this.id_comunicacion,
					valoracion: this.valoracion,
					observaciones: this.observaciones
				});
			},
			redireccionLogin: function(){
				router.replace('/login');
				this.$store.commit('establecerGuardadoOK', false);
			}
		},
		watch:{
			guardadoOK: function(newValue){
				if (newValue){
					this.$toast.open({
						message: "Su valoración se ha guardado correctamente",
						type: "success",
						duration: 3000,
						dismissible: false,
						position: "top",
						onDismiss: this.redireccionLogin
					});
					this.valoracionEnviada = true;
				}
			}
		},
		computed:{
			textoBtnEnvio: function() {
				if (this.enviandoDatosFormulario) return 'Enviando...';
				return 'Enviar';
			},
			enviandoDatosFormulario: function(){
				return this.$store.state.enviandoDatosFormulario; 
			},
			guardadoOK: function(){
            	return this.$store.state.guardadoOK;
        	},
			datosVacacionesParaValoracion: function(){
				return this.$store.state.datosVacacionesParaValoracion;
			},
			nombreTrabajador: function(){
				return this.datosVacacionesParaValoracion.nombreTrabajador || "";
			},
			fechaDesde:function(){
				return this.moment(this.datosVacacionesParaValoracion.fechaDesde).format('DD/MM/YYYY') || "";
			},
			fechaHasta:function(){
				return this.moment(this.datosVacacionesParaValoracion.fechaHasta).format('DD/MM/YYYY') || "";
			},
			dias:function(){
				return this.datosVacacionesParaValoracion.dias || "";
			},
			id_comunicacion: function(){
				return this.datosVacacionesParaValoracion.id_comunicacion || "";
			}
		}
    };
</script>

<style>
    @import "../assets/styles/home.css";
	.radio_aprob{
		display: inline; 
		margin-right: 5px !important;
	}
</style>